/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ type: NonNullable<unknown> }} License_TypeInputs */



/**
* | output |
* | --- |
* | "License type: {type}" |
*
* @param {License_TypeInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const license_type = /** @type {((inputs: License_TypeInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<License_TypeInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Type de licence : ${i?.type}`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Lizenztyp: ${i?.type}`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Tipo di licenza: ${i?.type}`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Тип лицензии: ${i?.type}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Tipo de licencia: ${i?.type}`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`许可证类型：${i?.type}`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`ライセンスタイプ: ${i?.type}`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`लाइसेंस प्रकार: ${i?.type}`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Tipo de licença: ${i?.type}`)
	return /** @type {LocalizedString} */ (`License type: ${i?.type}`)
});